import React, {useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import './CalibrationValuesModal.scss'

import ButtonSpinner from "../_common/ButtonSpinner";
import {toggleModal} from "../../store/actions/toggleModalActions";
import {addCalibrationValue, updateCalibrationValue} from "../../store/actions/calibrationValuesActions";


const selector = state => {
    const { language, disableButtons, calibrationValues } = state;
    return {
        t: language.translator,
        disableButtons: disableButtons,
        selected: calibrationValues.selected.calibrationValue,
        calibrationMeasurementTypes: calibrationValues.calibrationMeasurementTypes,
    }
};

const defaultValueSets = [
    {innerId: 1,},
    {innerId: 2,},
    {innerId: 3,},
]

const CalibrationValuesModal = props => {
    const dispatch = useDispatch();
    const { t, disableButtons, calibrationMeasurementTypes, selected } = useSelector(selector);
    const {edit} = props;
    const [measurementType, setMeasurementType] = useState(null)
    const [calibrationValuesName, setCalibrationValuesName] = useState('')
    const [calibrationValuesUnitName, setCalibrationValuesUnitName] = useState('')
    const [measurementOptions, showMeasurementOptions] = useState(false);
    const [calibrationValues, setCalibrationValues] = useState(defaultValueSets)


    useEffect(() => {
        if(edit) {
            setCalibrationValuesName(selected.setName)
            setMeasurementType(calibrationMeasurementTypes.find(x => x.measurementType === selected.measurementType))
            setCalibrationValuesUnitName(selected.unitName ? selected.unitName : '')
            const values = selected.values.map(el => (
                {...el, innerId: el.id}
            ))
            setCalibrationValues(values)
        }
    },[])

    const closeModal = () => {
        dispatch(toggleModal(false, ''));
    };

    const inputValues = (innerId, key, value) => {
        let inventory = {};
        const findInventory = calibrationValues.find(el => el.innerId === innerId)
        if(findInventory) {
            findInventory[key] = value
        } else {
            inventory.innerId = innerId
            inventory[key] = value
            setCalibrationValues([...calibrationValues, inventory])
        }
    }

    const handleAddCalibrationValuesClick = () => {
        if(measurementType && calibrationValuesName) {
            let body= {
                setName: calibrationValuesName,
                measurementType: measurementType.measurementType,
                unitName: calibrationValuesUnitName,
                values: calibrationValues.map(el => ({originalValue: el.originalValue ? Number(el.originalValue) : null, thirdPartyValue: el.thirdPartyValue ? Number(el.thirdPartyValue) : null}))
            }
            dispatch(addCalibrationValue(body))
            closeModal()
        }
    }

    const handleEditCalibrationValuesClick = () => {
        if(measurementType && calibrationValuesName) {
            let body= {
                setId: selected.setId,
                setName: calibrationValuesName,
                measurementType: measurementType.measurementType,
                unitName: calibrationValuesUnitName,
                values: calibrationValues.map(el => ({id: el.id, originalValue: el.originalValue ? Number(el.originalValue) : null, thirdPartyValue: el.thirdPartyValue ? Number(el.thirdPartyValue) : null}))
            }
            dispatch(updateCalibrationValue(body))
            closeModal()
        }
    }

    return (
        <div
            onClick={e => {
                if(e.target.className === 'fieldModalBlur') {
                    closeModal()
                }
            }}
            className="fieldModalBlur">
            <div className='fieldModal'>
                <div className='fieldModalHeader'>
                    <div className='fieldModalTitleContainer'>
                        <div className='fieldModalTitle'>
                            {edit ? t.gettext('Edit Calibration Value Set') : t.gettext('Add Calibration Value Set')}
                        </div>
                    </div>
                    <div className='fieldModalCloseButtonHolder'>
                        <span
                            className='material-icons fieldModalCloseButton'
                            onClick={closeModal}
                        >
                            cancel
                        </span>
                    </div>
                </div>
                <div className='fieldModalContent'>
                    <form className='fieldForm' autoComplete='off'>
                        <div className='fieldFormItem'>
                            <label className='fieldFormLabel'>
                                {t.gettext('Name')}
                            </label>
                            <input
                                className='fieldFormInput'
                                onInput={e => {
                                    setCalibrationValuesName(e.target.value);
                                }}
                                value={calibrationValuesName}
                                type='text'
                            />
                        </div>
                        <div className='fieldFormItem'>
                            <label className='fieldFormLabel'>
                                {t.gettext('Measurement Type')}
                            </label>
                            <div
                                className='userFormSelect'
                                onClick={() => showMeasurementOptions(!measurementOptions)}
                            >
                                <div className='userFormSelectText'>
                                    {measurementType?.measurementTypeName}
                                </div>
                                <i className="material-icons dropDownIcon">
                                    {measurementOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                                </i>
                                {measurementOptions &&
                                    <div className='userFormSelectOptions'>
                                        {calibrationMeasurementTypes.map((item, index) => (
                                            <div
                                                className='userFormSelectOption'
                                                key={index}
                                                onClick={() => setMeasurementType(item)}
                                            >
                                                {item.measurementTypeName}
                                            </div>
                                        ))}
                                    </div>
                                }
                            </div>
                        </div>
                        <div className='fieldFormItem'>
                            <label className='fieldFormLabel'>
                                {t.gettext('Unit Name')}
                            </label>
                            <input
                                className='fieldFormInput'
                                onInput={e => {
                                    setCalibrationValuesUnitName(e.target.value);
                                }}
                                value={calibrationValuesUnitName}
                                type='text'
                            />
                        </div>
                        {calibrationValues.map(el => (
                            <div className='fieldFormItem'>
                                <div className="calibrationValuesItem">
                                    <div className="calibrationValuesWrapper">
                                        <label className='fieldFormLabel'>
                                            {t.gettext('Orig Val')}
                                        </label>
                                        <input
                                            className='fieldFormInput'
                                            onChange={e => {
                                                inputValues(el.innerId, 'originalValue',e.target.value);
                                            }}
                                            defaultValue={calibrationValues.find(x => x.innerId === el.innerId).originalValue}
                                            type='number'
                                        />
                                    </div>
                                    <div className="calibrationValuesWrapper">
                                        <label className='fieldFormLabel'>
                                            {t.gettext('3rd Party Val')}
                                        </label>
                                        <input
                                            className='fieldFormInput'
                                            onChange={e => {
                                                inputValues(el.innerId, 'thirdPartyValue',e.target.value);
                                            }}
                                            defaultValue={calibrationValues.find(x => (x.innerId) === el.innerId).thirdPartyValue}
                                            type='number'
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}


                        <div className='fieldButtonsHolder'>
                            <button
                                className='fieldAddButton fieldEditButton'
                                onClick={e => {
                                    e.preventDefault();
                                    edit ? handleEditCalibrationValuesClick() :
                                        handleAddCalibrationValuesClick();
                                }}
                                disabled={disableButtons}
                            >
                                {t.gettext('Save')}
                                {disableButtons && <ButtonSpinner black/>}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )

}

export default CalibrationValuesModal
